import React from 'react';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import type { FaqItem } from '../../types/faq';
import { resolveIcon } from '../../lib/iconMap';

export function FaqVisualAnswer({ item }: { item: FaqItem }) {
  return (
    <div className="wfx-faq-visual">
      <p className="wfx-faq-lead">{item.a}</p>

      {item.visual === 'grid' && (item.grid?.length ?? 0) > 0 && (
        <div className="wfx-faq-type-grid">
          {item.grid!.map((entry) => {
            const Icon = resolveIcon(entry.icon, resolveIcon('Briefcase'));
            return (
              <div key={entry.label} className={`wfx-faq-type-card tone-${entry.tone ?? 'neutral'}`}>
                <Icon size={20} aria-hidden="true" />
                <span>{entry.label}</span>
              </div>
            );
          })}
        </div>
      )}

      {item.visual === 'flow' && (item.flow?.length ?? 0) > 0 && (
        <div className="wfx-faq-flow">
          {item.flow!.map((node, index) => {
            const Icon = resolveIcon(node.icon, resolveIcon('Sparkles'));
            const isArrow = node.icon === 'ArrowRight' || !node.label;
            if (isArrow) {
              return (
                <span key={`arrow-${index}`} className="wfx-faq-flow-arrow" aria-hidden="true">
                  <ArrowRight size={18} />
                </span>
              );
            }
            return (
              <div key={node.label} className="wfx-faq-flow-node glass-surface">
                <Icon size={20} aria-hidden="true" />
                <span>{node.label}</span>
              </div>
            );
          })}
        </div>
      )}

      {item.bullets && item.bullets.length > 0 && (
        <ul className="wfx-faq-bullets">
          {item.bullets.map((bullet) => (
            <li key={bullet}>
              <CheckCircle2 size={16} aria-hidden="true" />
              <span>{bullet}</span>
            </li>
          ))}
        </ul>
      )}

      {item.visual === 'steps' && (item.steps?.length ?? 0) > 0 && (
        <ol className="wfx-faq-steps">
          {item.steps!.map((step, index) => {
            const Icon = resolveIcon(step.icon, resolveIcon('Bell'));
            return (
              <li key={step.label}>
                <span className="wfx-faq-step-num">{index + 1}</span>
                <div className="wfx-faq-step-body glass-surface">
                  <div className="wfx-faq-step-head">
                    <Icon size={18} aria-hidden="true" />
                    <strong>{step.label}</strong>
                  </div>
                  {step.detail && <p>{step.detail}</p>}
                </div>
              </li>
            );
          })}
        </ol>
      )}

      {item.visual === 'compare' && item.compare && (
        <div className="wfx-faq-compare">
          {[item.compare.left, item.compare.right].map((side) => (
            <div key={side.title} className={`wfx-faq-compare-card tone-${side.tone ?? 'neutral'}`}>
              <strong>{side.title}</strong>
              <ul>
                {side.items.map((entry) => (
                  <li key={entry}>{entry}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
